// Header.jsx
import React, { useState, useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './Header.css';
import { AiOutlineHeart, AiOutlineHome, AiOutlinePhone, AiOutlineShop, AiOutlineShopping } from 'react-icons/ai';

const Header = () => {
  const navigate = useNavigate();
  const [userData, setUserData] = useState(null);
  const [openDropdown, setOpenDropdown] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const dropdownRef = useRef();
   const [isLowEndDevices, setIsLowEndDevices] = useState(window.innerWidth <= 950);

   const location = useLocation();

   const isActive = (path) => location.pathname === path;

  useEffect(() => {
    const data = localStorage.getItem('userData');
  
    if (data) {
      let parsedData = JSON.parse(data);
  
  
      // Check if parsedData is still a string (double stringified case)
      if (typeof parsedData === 'string') {
        parsedData = JSON.parse(parsedData);
      }
  
      if (parsedData && parsedData[0]) {
        setUserData(parsedData[0])
      }
    }
    else {
      localStorage.removeItem("authToken");
      localStorage.removeItem("userData");
      localStorage.removeItem("accessToken")
      localStorage.removeItem('refreshToken');
    }
        const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpenDropdown(false);
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);

useEffect(() => {
  const accessToken = localStorage.getItem('accessToken');
  const isInvalidToken =
    !accessToken ||
    accessToken === 'undefined' ||
    accessToken === 'null' ||
    accessToken.trim() === '';

  if (isInvalidToken) {
    handleLogout();
  }
}, []);

  
 
  
    useEffect(() => {
    const handleResize = () => setIsLowEndDevices(window.innerWidth <= 950);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);


  // useEffect(() => {
  //   const data = JSON.parse(localStorage.getItem('userData'));
  //   if (data && data.length > 0) setUserData(data[0]);

  //   const handleClickOutside = (e) => {
  //     if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
  //       setOpenDropdown(false);
  //     }
  //   };
  //   document.addEventListener('click', handleClickOutside);
  //   return () => document.removeEventListener('click', handleClickOutside);
  // }, []);

  const handleLogout = () => {
  
    // Clear all authentication data
    localStorage.removeItem("authToken");
    localStorage.removeItem("userData");
    localStorage.removeItem("accessToken")
    localStorage.removeItem('refreshToken');

    // Clear user state
    setUserData(null);
    setOpenDropdown(false);

   navigate(`/login`);
  };

  return (
    <header className="header">
      <div className="header-content">
        {/* Mobile Menu Toggle */}
        <button
          className="mobile-menu-toggle"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          {isMenuOpen ? '✕' : '☰'}
        </button>

        <nav className={`nav-menu ${isMenuOpen ? 'mobile-open' : ''}`}>
          <a href="#" className="nav-item" onClick={(e) => { e.preventDefault(); navigate('/home'); setIsMenuOpen(false);}} style={{padding:"0px 1.6vw",color: isActive('/home') ? "#ff6b35" : '',display:"flex",justifyContent:isLowEndDevices?"left":"center",flexDirection:"row",fontWeight:600}}>
            <AiOutlineHome size={16} /> HOME
          </a>
          <a href="#" className="nav-item" onClick={(e) => { e.preventDefault(); navigate('/shop'); setIsMenuOpen(false); }} style={{padding:"0px 1.6vw",color: isActive('/shop') ? "#ff6b35" : '',display:"flex",justifyContent:isLowEndDevices?"left":"center",flexDirection:"row",fontWeight:600}}>
            <AiOutlineShop  size={16} /> SHOP
          </a>
          <a href="#" className="nav-item" onClick={(e) => { e.preventDefault(); navigate('/wishlist'); setIsMenuOpen(false); }} style={{padding:"0px 1.6vw",color: isActive('/wishlist') ? "#ff6b35" : '',display:"flex",justifyContent:isLowEndDevices?"left":"center",flexDirection:"row",fontWeight:600}}>
            <AiOutlineHeart size={16} /> WISHLIST
          </a>
          {/* <a href="#" className="nav-item" onClick={() => setIsMenuOpen(false)}>
            <span className="nav-icon">🎫</span> RAISE A TICKET
          </a> */}
          {/* <a href="#" className="nav-item" onClick={() => setIsMenuOpen(false)}>
            <span className="nav-icon">✨</span> CLEARANCES
          </a> */}
          <a
            href="#"
            className="nav-item"
            onClick={(e) => {
              e.preventDefault();
              navigate('/contact');
              setIsMenuOpen(false);
            }}
            style={{padding:"0px 1.6vw",color: isActive('/contact') ? "#ff6b35" : '',display:"flex",justifyContent:isLowEndDevices?"left":"center",flexDirection:"row",fontWeight:600}}
          >
            <AiOutlinePhone size={16} style={{
                            transform: "scaleX(-1)",   // FLIP horizontally
                            transformOrigin: "center"
                          }}  /> CONTACT US

          </a>
          {/* <a href="#" className="nav-item" onClick={() => setIsMenuOpen(false)}>CERTIFICATE VAULT MANAGER</a> */}
        </nav>

        <div className="header-contact">
          <span className="phone-number">+971 4 2668871</span>
          <span className="support-text">24/7 support center</span>

          {userData && (
            <div className="user-dropdown" ref={dropdownRef}>
              {/* <img
                      src="https://cdn-icons-png.flaticon.com/512/847/847969.png"
                      alt="avatar"
                      className="avatar"
                    /> */}
                    {isLowEndDevices? 
              <button className="user-btn" onClick={() => setOpenDropdown(!openDropdown)}>
                {userData.LoginName} 
              </button>
              :null}

              {openDropdown && (
                <div className="dropdown-content">
                  {/* <div className="profile-section">
                    <img
                      src="https://via.placeholder.com/50"
                      alt="avatar"
                      className="avatar"
                    />
                    <div className="profile-info">
                      <span className="profile-name">{userData.LoginName}</span>
                      <span className="profile-role">User</span>
                    </div>
                  </div> */}
                  <button className="logout-btn" onClick={handleLogout}>
                    Log Out
                  </button>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
